/* Import necessary libraries and modules */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Admin from 'apis/Admin';
import { mapKeys } from 'lodash';

/* Define an asynchronous thunk for fetching unverified user data */
export const unverifiedUserRequest = createAsyncThunk(
  'unverifiedUserList',
  async ({ data, start, limit }) => {
    /* Make an asynchronous request to fetch unverified user data */
    const response = await Admin.post(`allUsers/${start}/${limit}`, data);
    return response.data.data;
  }
);

// Move to Pending User
export const pendingUserRequest = createAsyncThunk(
  'pendingUser',
  async ({ data }) => {
    await Admin.post('updateUserStatus', data);
    return data;
  }
);

/* Create a Redux slice for managing unverified user data state */
const unverifiedUserSlice = createSlice({
  name: 'unverifiedUser',
  initialState: {
    /* Initial state for the unverifiedUser slice */
    unverifiedUser: {} /* Holds unverified user data with _id as the key */,
    totalList: '' /* Total number of unverified users */,
    message: '' /* Any additional message related to the data */,
    loading: false /* Loading state indicator */,
  },
  reducers: {
    /* Standard reducer logic can be added here if needed */
  },
  extraReducers: {
    /* Add reducers for additional action types here, and handle loading state as needed */

    /* Handle the successful completion of the unverifiedUserRequest */
    [unverifiedUserRequest.fulfilled]: (state, action) => {
      /* Update the state with the fetched unverified user data */
      return {
        ...state,
        unverifiedUser: { ...mapKeys(action.payload.users, '_id') },
        totalList: action.payload.totalUsers,
        message: action.payload.message,
        loading: false,
      };
    },

    /* Handle the pending state of the unverifiedUserRequest */
    [unverifiedUserRequest.pending]: state => {
      /* Update the loading state to indicate the request is pending */
      return { ...state, loading: true };
    },

    /* Handle the rejection (error) state of the unverifiedUserRequest */
    [unverifiedUserRequest.rejected]: (state, action) => {
      /* Handle rejection by updating the state with an error message */
      return {
        ...state,
        unverifiedUser: action.payload,
        message: 'no data',
        loading: false,
      };
    },
    [pendingUserRequest.pending]: state => {
      return { ...state, loading: true };
    },
    [pendingUserRequest.rejected]: state => {
      return {
        ...state,
        loading: false,
      };
    },
    [pendingUserRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        message: action.payload.message,
        loading: false,
      };
    },
  },
});

/* Export the reducer for integration with the Redux store */
export default unverifiedUserSlice.reducer;
